// GET QUESTION LIST
export const GET_QUESTIONS_LIST_FAIL = "GET_QUESTIONS_LIST_FAIL";
export const GET_QUESTIONS_LIST_REQUEST = "GET_QUESTIONS_LIST_REQUEST";
export const GET_QUESTIONS_LIST_SUCCESS = "GET_QUESTIONS_LIST_SUCCESS";

// QUESTION DETAILS
export const QUESTION_DETAILS_FAIL = "QUESTION_DETAILS_FAIL";
export const QUESTION_DETAILS_REQUEST = "QUESTION_DETAILS_REQUEST";
export const QUESTION_DETAILS_SUCCESS = "QUESTION_DETAILS_SUCCESS";

// QUESTION DETAILS RESET
export const QUESTION_DETAILS_RESET = "QUESTION_DETAILS_RESET";

// QUESTION VERIFY
export const QUESTION_VERIFY_FAIL = "QUESTION_VERIFY_FAIL";
export const QUESTION_VERIFY_REQUEST = "QUESTION_VERIFY_REQUEST";
export const QUESTION_VERIFY_SUCCESS = "QUESTION_VERIFY_SUCCESS";

// EXTRACT QUESTION PDF
export const EXTRACT_QUESTION_PDF_FAIL = "EXTRACT_QUESTION_PDF_FAIL";
export const EXTRACT_QUESTION_PDF_REQUEST = "EXTRACT_QUESTION_PDF_REQUEST";
export const EXTRACT_QUESTION_PDF_SUCCESS = "EXTRACT_QUESTION_PDF_SUCCESS";
export const EXTRACT_QUESTION_PDF_RESET = "EXTRACT_QUESTION_PDF_RESET";

// BULK CREATE MCQ
export const BULK_CREATE_MCQ_FAIL = "BULK_CREATE_MCQ_FAIL";
export const BULK_CREATE_MCQ_REQUEST = "BULK_CREATE_MCQ_REQUEST";
export const BULK_CREATE_MCQ_SUCCESS = "BULK_CREATE_MCQ_SUCCESS";
export const BULK_CREATE_MCQ_RESET = "BULK_CREATE_MCQ_RESET";
